import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/")({
  // The unified hub is the landing: a common tile screen for both CRM
  // and ERP. Redirect happens before the route component would render,
  // so users never see a flash of an interstitial page.
  beforeLoad: () => {
    throw redirect({ to: "/home" });
  },
});
